// removed by extract-text-webpack-plugin
module.exports = {"info":"_2jP-"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersDisconnectModal/NumbersDisconnectModal.scss
// module id = nNmZ
// module chunks = 0